import React from 'react';

function TableHeader(props) {
    return (
        <thead className="team-head admin-help">
        <tr>
            <th>Code</th>
            <th>Name</th>
            <th>Edit</th>
        </tr>
        </thead>
    )
}

export default TableHeader;
